import { Button } from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';
import { useTranslation } from 'react-i18next';

import { LaboratoryInfoRequest, useLaboratoryUpdateInfo } from '@/module/Laboratory';
import { LabInfoChangeForm } from '@/module/Laboratory/info/LabInfoChangeForm';

import { Id, useAppNotification } from '@feature/utils';

export function LabInfoChangeButton({ labId, labInfo }: { labId: Id; labInfo: LaboratoryInfoRequest }) {
  const { mutate, isPending } = useLaboratoryUpdateInfo(labId);
  const { t } = useTranslation();
  const [opened, { open, close }] = useDisclosure(false);
  const notification = useAppNotification();

  const handleChange = (request: LaboratoryInfoRequest) =>
    mutate(request, {
      onError: notification.error,
      onSuccess: () => {
        notification.success();
        close();
      },
    });

  return (
    <>
      <Button
        size="xs"
        loading={isPending}
        onClick={open}
      >
        {t('labs.changeInfo')}
      </Button>
      {opened && (
        <LabInfoChangeForm
          onClose={close}
          isSubmitting={isPending}
          onChange={handleChange}
          defaultValues={labInfo}
        />
      )}
    </>
  );
}
